import UpdateThirdPartyUserRepository from './UpdateThirdPartyUserRepository.js'

const isRequired = field => {
  throw new Error(`BrazeUserRepository# ${field} is a mandatory parameter`)
}

export default class BrazeUserRepository extends UpdateThirdPartyUserRepository {
  constructor({config}) {
    super()

    this._config = config
    this._isCoches = this._config.get('APP_NAME') === this._config.get('APP_NAME_COCHES')
    this._sdrnBase = this._config.get('tracking').SDRN_BASE
  }

  async update({
    id = isRequired('id'),
    firstName = isRequired('firstName'),
    lastName = null,
    phoneNumber = null,
    email = isRequired('email'),
    isEmailConfirmed = null
  }) {
    const sdk = window.appboy
    let brazeUser

    if (!sdk) {
      console.warn('BrazeUserRepository#update: Braze SDK is not available') // eslint-disable-line
      return
    }

    // temporary check while Motos Braze situation is resolved
    if (this._isCoches) {
      // Necessary to be able to correctly reference the users that are in the arm with the events and requests that are made from the different sites
      const sdrnParsedId = `${this._sdrnBase}${id.toString()}`

      sdk.changeUser(sdrnParsedId)
      brazeUser = sdk.getUser() // eslint-disable-line
      brazeUser.setFirstName(firstName)
      brazeUser.setLastName(lastName)
      brazeUser.setPhoneNumber(phoneNumber)
      brazeUser.setEmail(email)
      brazeUser.setCustomUserAttribute('email_confirmed', isEmailConfirmed)
    }
  }
}
